// extracted by mini-css-extract-plugin
export default {"oferta":"Oferta_oferta__m17lp","section1":"Oferta_section1__4Wwpp","section2":"Oferta_section2__N9i5d"};